// Note: keep this synced btw the front and backends.
export function compareBoardItems(a, b) {
  const aSortOrder = a.sort_order ?? 0;
  const bSortOrder = b.sort_order ?? 0;
  const sortOrderComparison = aSortOrder - bSortOrder;

  if (sortOrderComparison !== 0) return sortOrderComparison;

  return b.updated_at - a.updated_at;
}
